import request from '@/utils/request'

export const getTableData = params =>
  request.post('/customer-api/bureau-report/page', params)
